import React, { useContext, useEffect, useState } from 'react';
import {
  IRFP_Context,
  IRFP_Questions,
  IRFPAnswers,
  ISelectedCell
} from '../../../lib/models/interfaces';
import {
  Button,
  Modal,
  Toggle,
  ButtonDropdown,
  ExpandableSection,
  Popover
} from '@cloudscape-design/components';
import { CitationText } from '../Chat/chatAnswer';
import { ICiteBlock } from '../Chat/chatWithSummaryNew';
import CiteBlockCard from '../Chat/contextBlockCard';
import { UserContext } from '../../../context/authContext';
import { CitationTextValidation } from './CitationTextValidation';
import { Copy, Pencil, Save } from 'lucide-react';
import { getIdsFromText } from './helpers';

const missingAnswerString =
  'We generated an answer, but it didn’t load properly.This usually means the response format wasn’t recognized, not that your request failed.Please try again, or contact support if this keeps happening.';
// export const getIdsFromText = (text: string): string[] => {
//   // const regex = /‹(.*?)›/g;
//   const regex = /<<cid:([A-Fa-f0-9]{24})>>/g;
//   const matches: string[] = [];
//   let match;
//   console.log('textMatch', text);
//   while ((match = regex.exec(text)) !== null) {
//     console.log('text ids function', match);
//     matches.push(match[1]);
//   }
//   console.log('textMatch matches', matches);
//   return matches;
// };
interface Props {
  data: IRFP_Questions;
  acceptAnswer: (index?: number) => void;
  validateAnswer: () => void;
  currentCell: ISelectedCell;
  handleUpdateFromEdit: (text: string, cell: ISelectedCell) => void;
  highLightNonValidatedCells: () => void;
}

const RFPAnswerCard: React.FC<Props> = ({
  data,
  acceptAnswer,
  validateAnswer,
  currentCell,
  handleUpdateFromEdit,
  highLightNonValidatedCells
}) => {
  // console.log('data in answercard', data);
  const { auth } = useContext(UserContext);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [citeBlocks, setCiteBlocks] = useState<IRFP_Context | null>(null);
  const [showTrace, setShowTrace] = useState<boolean>(false);
  const [citationObject, setCitationObject] = useState<{
    [key: string]: number;
  }>({});
  const [editing, setEditing] = useState<boolean>(false);
  const [textToEdit, setTextToEdit] = useState<string>('');
  const [showValidation, setShowValidation] = useState<boolean>(false);
  const [tooltipText, setTooltipText] = useState('Click to copy');

  const isPass = (val: IRFPAnswers['validation']): val is { text: string } => {
    return typeof val === 'object' && 'text' in val && val.text === 'Pass';
  };

  useEffect(() => {
    // console.log('updating citation object');

    if (data?.answer && data.answer.length > 0) {
      if (!data.answer[0]?.textInternal) return;
      const text = data.answer[0]?.textInternal ?? '';
      console.log('textInternal', text);
      // console.log('answer text', text);
      const idsWithIndex = getIdsFromText(text);
      console.log('gettting ids from textInternal', idsWithIndex);
      console.log('');
      const citeObj: { [key: string]: number } = {};
      let count = 1;
      idsWithIndex.forEach((ele) => {
        if (!citeObj[ele]) {
          citeObj[ele] = count;
          count++;
        }
      });
      // console.log('citeObj', citeObj);
      setCitationObject(citeObj);
    }
  }, [data.answer]);

  const handleCite = (id: string) => {
    // alert(`Cite clicked - ${id}`);
    // console.log('cite block', id);
    const citeBlock = data.context.filter((ele) => ele._id === id);
    if (citeBlock) {
      setCiteBlocks(citeBlock[0]);
    }

    setShowModal(true);
  };
  const updateAnswer = () => {
    handleUpdateFromEdit(textToEdit, currentCell);
    setTextToEdit('');
    setEditing(false);
  };

  function htmlToPlainText(htmlString: string) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    return tempDiv.textContent || tempDiv.innerText || '';
  }
  //TODO fix this regex
  // const copyToClipboard = async (text: string) => {
  //   const regex = /‹[a-f0-9]{24}›/g;
  //   const plainText = htmlToPlainText(text);
  //   const result = plainText.replace(regex, '');
  //   await navigator.clipboard.writeText(result);
  //   setTooltipText('Copied!');
  //   setTimeout(() => setTooltipText('Click to copy'), 2000);
  // };

  const copyToClipboard = async (text: string) => {
    // const regex = /<\d+>/g;
    const plainText = htmlToPlainText(text);
    // const result = plainText.replace(regex, '');
    await navigator.clipboard.writeText(plainText);

    setTooltipText('Copied!');
    setTimeout(() => setTooltipText('Click to copy'), 2000);
  };

  //   const buttonClass = `px-4 h-8 text-sm font-medium text-[#006CE0] bg-transparent border-2 border-[#006CE0]
  // hover:bg-[#006CE0] hover:text-white
  // focus:z-10 focus:ring-2 focus:ring-[#006CE0] focus:bg-[#006CE0] focus:text-white
  // dark:border-white dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:bg-gray-700
  // rounded-3xl
  // `;
  const buttonClass = `px-4 h-8 text-sm font-medium text-[#006CE0] bg-transparent border-2 border-[#006CE0] 
hover:bg-[#006CE0] hover:text-white 
focus:z-10 focus:ring-2 focus:ring-[#006CE0] focus:bg-[#006CE0] focus:text-white rounded-3xl
`;

  return (
    <div className="border rounded-md shadow p-2 mb-4 bg-white h-[60vh] overflow-auto">
      <div className="flex justify-start items-center mb-2">
        <h3 className="text-lg font-semibold">Answer</h3>

        <div className="flex w-full justify-end space-x-2">
          {!editing ? (
            <button
              type="button"
              className={buttonClass}
              onClick={() => {
                setEditing(true);
                setTextToEdit(data.answer[data.answer.length - 1].text);
              }}
            >
              Edit
            </button>
          ) : (
            <button
              type="button"
              className={buttonClass}
              onClick={() => updateAnswer()}
            >
              Save
            </button>
          )}

          {data.answer.length >= 2 && !showTrace && (
            <button
              type="button"
              className={buttonClass}
              onClick={() => setShowTrace(true)}
            >
              Show Trace
            </button>
          )}
          {showTrace && (
            <button
              type="button"
              className={buttonClass}
              onClick={() => setShowTrace(false)}
            >
              Hide Trace
            </button>
          )}
          {isPass(data.validation) && !data.userValidated && (
            <button
              type="button"
              className={buttonClass}
              onClick={() => validateAnswer()}
            >
              Validate
            </button>
          )}
          {!data.userValidated &&
            !isPass(data.validation) &&
            Array.isArray(data.validation) &&
            data.answer.length === 1 &&
            !editing && (
              <button
                type="button"
                className={buttonClass}
                onClick={() => acceptAnswer()}
              >
                Accept
              </button>
            )}
        </div>
      </div>
      <div className="border bg-gray-100 p-4 rounded-md space-y-2">
        {editing && (
          <div className="w-full">
            {textToEdit.length > 0 && (
              <textarea
                value={textToEdit}
                onChange={(e) => setTextToEdit(e.target.value)}
                className="w-full min-h-[200px] resize-vertical"
                style={{ minHeight: '200px' }}
              ></textarea>
            )}
          </div>
        )}
        {data?.answer?.length > 0 && !editing && (
          <>
            <div className="border p-4 rounded-md">
              <div className="flex flex-row justify-between align-center">
                <h2>External Answer</h2>

                {/* <div className="">
                  <Popover
                    dismissButton={false}
                    position="top"
                    size="small"
                    triggerType="custom"
                    content={tooltipText}
                  >
                    <Copy
                      size={16}
                      onClick={() =>
                        copyToClipboard(
                          data.answer[data.answer.length - 1].text ?? ''
                        )
                      }
                      className="cursor-pointer p-0"
                    />
                  </Popover>
                </div> */}
              </div>

              <CitationText
                text={
                  data.answer[data.answer.length - 1].text ??
                  missingAnswerString
                }
                onCiteClick={handleCite}
                prevAnswer={false}
                citationObject={citationObject}
                type={'rfp'}
                contextArray={data.context}
                any={{ ExternalAnswer: true }}
              />
            </div>
            <div className="border p-4 rounded-md">
              <div className="flex flex-row justify-between align-center">
                <h2>Internal Answer</h2>
                {/* <div className="">
                  <Popover
                    dismissButton={false}
                    position="top"
                    size="small"
                    triggerType="custom"
                    content={tooltipText}
                  >
                    <Copy
                      size={16}
                      onClick={() =>
                        copyToClipboard(data.answer[0]?.textInternal ?? '')
                      }
                      className="cursor-pointer p-0"
                    />
                  </Popover>
                </div> */}
              </div>
              <CitationText
                text={data.answer[0]?.textInternal ?? ''}
                onCiteClick={handleCite}
                prevAnswer={false}
                citationObject={citationObject}
                type={'rfp'}
                contextArray={data.context}
              />
            </div>
          </>
        )}

        {data.answer[data.answer.length - 1]?.user === 'system' && !editing ? (
          <p className="p-4">
            Answer Provided By: {data.answer[data.answer.length - 1].user}
          </p>
        ) : null}

        {data.userValidated && !editing ? (
          <p className="p-4">Validated by: {data.validatedBy[0]}</p>
        ) : null}
        {/* {!data.userValidated && (
          <div className="flex justify-end mt-4">
            <Button onClick={() => validateAnswer()}>Validate 1</Button>
          </div>
        )} */}
        <div>
          {data.answer.length >= 2 &&
            showTrace &&
            data.answer
              .slice(0, -1)
              .reverse()
              .map((ele, index) => (
                <>
                  <CitationText
                    text={ele.text}
                    onCiteClick={handleCite}
                    prevAnswer={false}
                    type={'rfp'}
                    contextArray={data.context}
                  />
                  {ele.user === 'System' ? (
                    <p className="p-4">Answer Provided By: {ele.user}</p>
                  ) : (
                    <p className="p-4">Provided By: {ele.user}</p>
                  )}
                </>
              ))}
        </div>
        {/* {data.previousAnswer && (
          <div>
            <p className="font-bold underline">Previous Question</p>
            <p className="italic font-bold">{data.previousAnswer[0].text}</p>
            <p className="font-bold underline">The Document</p>
            <p className="italic font-bold">
              {data.previousAnswer[0].Document.documentFileName}
            </p>
            {!data.userValidated && (
              <div className="flex justify-end mt-4">
                <Button onClick={() => validateAnswer()}>Validate 6</Button>
              </div>
            )}
          </div>
        )} */}
      </div>

      {showValidation ||
        (!data.userValidated && (
          <>
            {!isPass(data.validation) &&
              Array.isArray(data.validation) &&
              data.answer.length === 1 &&
              !editing && (
                <div>
                  <h4 className="text-md font-medium mb-2 text-red-600">
                    Validation Issues
                  </h4>
                  <ul className="list-disc ml-5">
                    {data.validation.map((v, i) => (
                      <li key={i} className="mb-1">
                        <strong>Claim:</strong> {v.claim} <br />
                        <strong>Reason:</strong>{' '}
                        <CitationTextValidation
                          text={v.reason ?? ''}
                          onCiteClick={handleCite}
                          citationObject={citationObject}
                        />
                      </li>
                    ))}
                  </ul>
                  {/* <div className="flex flex-row justify-end">
              <Button onClick={() => acceptAnswer()}>Accept 5</Button>
            </div> */}
                </div>
              )}
          </>
        ))}

      {data.previousAnswer && data.previousAnswer.length > 0 && (
        <div className="border bg-gray-100 p-4 rounded-md">
          <h3 className="text-lg font-semibold">Similar Saved Q and A</h3>
          {data.previousAnswer.map((ele: any, index: number) => (
            <div>
              <div className="flex justify-between mt-1 pl-2 px-2 py-1"></div>

              {/* <div className="mt-4 pl-2 px-2 py-1 rounded-md border border-gray-500">
                <span className="font-bold mr-2">Q:</span>
                <span className="italic font-bold">{ele.text}</span>
                </div> */}
              <div className="mt-4 pl-2 px-2 py-1 rounded-md border border-gray-500">
                {/* <span className="font-bold mr-2">A:</span> */}
                <ExpandableSection headerText={ele.text}>
                  <span> Similarity: {(ele.score * 100).toFixed(0)}%</span>
                  <span className="italic font-bold">
                    <h4>External Answer</h4>
                    <CitationText
                      text={`${ele.answer}`}
                      onCiteClick={handleCite}
                      prevAnswer={true}
                      contextArray={data.context}
                      type={'rfp'}
                    />
                  </span>
                  <span className="italic font-bold">
                    <h4>Internal Answer</h4>
                    <CitationText
                      text={`${ele.originalInternalAnswer}`}
                      onCiteClick={handleCite}
                      prevAnswer={true}
                      contextArray={data.context}
                      type={'rfp'}
                      any={{
                        prevExternalAnswer: true,
                        originalHardCitations: ele?.originalHardCitations ?? []
                      }}
                    />
                  </span>
                  <div className="flex justify-between mt-4 pl-2 px-2 py-1 rounded-md bg-blue-100 text-blue-800 font-mono">
                    <span>{ele.Document.documentFileName}</span>
                    {/* <span> Similarity: {(ele.score * 100).toFixed(0)}%</span> */}
                  </div>
                  <div className="flex justify-end mt-4">
                    <Button onClick={() => acceptAnswer(index)}>
                      Use this Answer
                    </Button>
                  </div>
                </ExpandableSection>
              </div>
            </div>
          ))}
        </div>
      )}
      <Modal
        visible={showModal}
        onDismiss={() => setShowModal(false)}
        size="large"
      >
        {citeBlocks && (
          <CiteBlockCard
            citeBlock={citeBlocks}
            auth={auth}
            pinCiteBlock={() => {}}
            pinAdd={true}
            view={'rfp'}
            goToSpecificPage={() => {}}
            closeModal={setShowModal}
            showSearchBox={true}
          />
        )}
      </Modal>
    </div>
  );
};

export default RFPAnswerCard;
